import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Modal } from 'react-bootstrap'

import base from 'Styles/base.css'
import style from './style.css'

import closeIcon from 'Assets/x-icon-gray.svg'

function NetworkIssueModal (props) {
  return (
    <Modal show={true}>
      <div className={style.containerModal}>
        <Modal.Header className={classnames('modal-header', style.headerContainer)}>
          <button
            data-test-id="closeNetworkIssueModal"
            aria-label="Close Edit Topics"
            className={classnames(style.closeEditTarget, style.hideModal)}
            onClick={props.onClose}
            tabIndex="0"
          >
            <object
              data={closeIcon} type="image/svg+xml"
              className={base.svgIcon}
              tabIndex="-1"
            />
          </button>
          <Modal.Title className={style.title}>
            {'Connection Error: further progress will not be recorded'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={style.text} tabIndex="0">
          {'There is a network issue, and your progress is no longer being saved. To fix the problem, confirm your internet connection and sign back into your course. If the problem persists, contact technical support.'}
          <br/><br/>
          {'If you complete your Adaptive Quiz activity without an internet connection your grade will not be recorded.'}
        </Modal.Body>
        <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
          <button
            className={classnames('btn-cdl-main', style.btnClose)}
            onClick={props.onClose}
            data-test-id="closeNetworkIssueModal"
          >
            Got It!
          </button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

NetworkIssueModal.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default NetworkIssueModal
